<template>
  <div>
    <single-book />
  </div>
</template>

<script>
import SingleBook from '@/components/SingleBook.vue';
export default {
  name: 'BookDetails',
  components: { SingleBook },
}
</script>

<style scoped>
</style>

